import { DropdownToggle, FormGroup, InputGroup } from 'reactstrap'
import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

export const ContentWrapper = styled.div`
  margin-top: 20px;

  @media ${queries.less.md} {
    margin: 20px -1.2rem;
  }
`

export const Container = styled.div`
  border: 1px solid #e4e9ec;
  border-radius: 8px;
  display: grid;
  grid-template-columns: 25% 1fr;

  @media ${queries.less.md} {
    grid-template-columns: 1fr;
    background: #fff;
  }
`

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 25px;
`

export const Body = styled.div`
  padding: 25px 30px;
  max-width: 100vw;
`

export const FilterPanelContainer = styled.div`
  background: #fff;
  border-right: 1px solid #e4e9ec;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;

  & > div:last-child {
    border: none;
  }
`

export const FilterSection = styled.div`
  padding: 25px 30px;
  border-bottom: 1px solid #efefef;
`

export const SearchInput = styled(FormGroup)`
  position: relative;

  input {
    border-radius: 24px;
    height: 48px;
    font-size: 1.1rem;
    padding-left: 15px;

    &::placeholder {
      font-size: 1.1rem;
    }
  }

  .input-icon-right {
    margin: 5px 5px 0 0;
  }
`

export const SubHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  strong {
    font-size: 22px;
    color: #767676;
  }

  & > div:last-child {
    display: flex;
    gap: 10px;

    & > div {
      min-width: 160px;
    }
  }
`

export const DropdownButton = styled(DropdownToggle).attrs({
  tag: 'span',
  caret: true,
})`
  cursor: pointer;
  padding: 8px 13px;
  height: 100%;

  span {
    display: none;
  }

  @media ${queries.more.md} {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #c4c4c4;
    margin-bottom: 0 !important;

    span {
      display: block;
      user-select: none;
    }

    #mobile-view {
      display: none;
    }
  }
`

export const VariablesDropdownButton = styled(DropdownToggle).attrs({
  tag: 'span',
  caret: true,
})`
  cursor: pointer;
  padding: 8px 13px;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-radius: 6px;
  border: 1px solid #c4c4c4;
  margin-bottom: 0 !important;

  span {
    user-select: none;
  }
`

export const FilterToggle = styled.div`
  cursor: pointer;
`

export const NewCommentContent = styled.div`
  background: ${props => props.theme.color.primary};
  color: #fff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.161);

  padding: 20px 25px;
  border-radius: 8px;
  margin-top: 15px;

  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const NewCommentFooter = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 20px;

  @media (max-width: 992px) {
    button {
      width: 100%;
    }
  }
`

export const NewCommentFooterInputGroup = styled(InputGroup)`
  flex-wrap: nowrap;
  @media (min-width: 992px) {
    width: fit-content;
  }
`

export const NewCommentFooterItem = styled.div`
  @media (max-width: 992px) {
    width: 100%;
  }
`
